module.exports = __webpack_public_path__ + "static/img/id-license.2bc243a1.png";